function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXlsPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2134 2134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2094.21,294.292l-255.208,-255.209c-24.792,-25.037 -58.958,-39.083 -94.375,-39.083l-681.667,-0c-147.291,-0 -266.666,119.417 -266.666,266.667l0.081,1066.67c3.669,147.5 123.252,266.667 270.335,266.667l800,0c146.667,0 266.667,-120 266.667,-266.667l0,-944.791c0,-35.334 -14.167,-69.25 -39.167,-94.25Zm-160.833,1039.04c0,36.817 -29.85,66.667 -66.667,66.667l-803.75,0c-36.825,0 -66.666,-29.85 -66.666,-66.667l-0,-1066.12c-0,-36.816 29.85,-66.666 66.666,-66.666l533.334,-0l3.75,199.458c-0,73.625 59.708,133.333 133.333,133.333l196.25,0l0,800l3.75,0Zm-800,533.334c0,36.816 -29.85,66.666 -66.667,66.666l-803.75,0c-36.825,0 -66.666,-29.85 -66.666,-66.666l3.666,-1066.25c0,-36.817 29.85,-66.667 66.667,-66.667l400.083,-0l0,-200.417l-400.041,0c-147.292,0 -266.667,119.375 -266.667,266.667l0.041,1066.67c0.009,147.083 119.417,266.666 266.667,266.666l800,0c146.667,0 266.667,-120 266.667,-266.666l-0,-133.334l-196.25,0l-3.75,133.334Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.770297,0,-219.222)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "1002.41px",
    y: "1669.34px",
    style: {
      fontFamily: "'DINCondensed-Bold', 'DIN Condensed'",
      fontWeight: 700,
      fontStretch: "condensed",
      fontSize: "752.074px"
    }
  }, "PDF")), /*#__PURE__*/React.createElement("path", {
    d: "M474.618,1396.39l-67.162,141.096l-117.062,-0l156.083,-311.429l-144.16,-283.04l117.062,-0l83.461,176.17l84.544,-176.17l117.062,-0l-147.411,283.04l43.928,85.86l255.568,0l0,497.699l-381.913,-0l0,-413.226Zm188.038,331.905l-182.312,0l0,72.468l182.312,-0l-0,-72.468Zm188.15,0l-182.312,0l0,72.468l182.312,-0l-0,-72.468Zm-188.15,-81.529l-182.312,0l0,72.468l182.312,-0l-0,-72.468Zm188.15,0l-182.312,0l0,72.468l182.312,-0l-0,-72.468Zm-188.15,-81.43l-182.312,-0l0,72.182l182.312,-0l-0,-72.182Zm188.15,-0l-182.312,-0l0,72.182l182.312,-0l-0,-72.182Zm-277.24,-81.321l-93.222,0l0,72.182l182.312,0l-0,-18.711l-63.349,-0l-25.741,-53.471Zm115.446,0l27.357,53.471l-47.875,-0l0,18.711l182.312,0l-0,-72.182l-161.794,0Zm-154.696,-81.529l-53.972,0l0,72.468l88.859,0l-34.887,-72.468Zm150.06,72.468l166.43,0l-0,-72.468l-182.312,0l0,41.426l15.882,31.042Zm-37.076,-72.468l15.356,30.014l-0,-30.014l-15.356,0Zm-166.956,-18.124l0,8.876l49.52,-0l-27.024,-56.135l-22.496,47.259Zm370.462,-63.592l-182.312,0l0,72.468l182.312,-0l-0,-72.468Zm-245.314,0l37.076,72.468l20.088,-0l-0,-72.468l-57.164,0Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsPdf);
export default __webpack_public_path__ + "static/media/xls_pdf.41b17e5365b18a422465b5feacf34ac8.svg";
export { ForwardRef as ReactComponent };